const PropTypes = require('prop-types');
// @vendors
const React = require('react');

// @helpers
const { FormattedText } = require('core/i18n').i18n;
const ClassNames = require('classnames');

// @components
const { OKButton } = require('components/commons/OKButton/OKButton');
const Flag = require('components/broker/commons/flag/flag');
// @constants
const {
    BROKER_SMALL_FLAG_SIZE
} = require('constants/index');

class WidgetSearchProducts extends React.Component {
    constructor(props) {
        super(props);
        this.handleMouseDown = this.handleMouseDown.bind(this);
    }

    handleMouseDown(event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onSelect(this.props.option);
    }

    render() {
        const { isFocused, option } = this.props;

        let optionElement;

        if (!option.disabled && !option.showMoreLink && !option.hide) {
            const optionsClass = ClassNames(
                'broker-search-input-option__results-item broker-search-input-option__results-widget-product-item',
                {
                    'broker-search-input-option__results-widget-product-item--focus': isFocused
                }
            );
            const {term, widgetSearchProductLabel, market} = option;
            const label = widgetSearchProductLabel;
            const field = label.toLowerCase();
            const termIndex = field.indexOf(term);
            let marketloc = '';
            let flag = '';
            let marketInfo = '';

            if (market) {
                const countryCode = market.ISO_COUNTRY_CODE;
                marketloc = ' ' + market.CITY + ', ' + countryCode + ' | ';
                flag = <Flag countryCode={countryCode} pixelsSize={BROKER_SMALL_FLAG_SIZE} />;
            }
            marketInfo = <div> {flag}{marketloc}{option.instrumentId} </div>

            if (termIndex !== -1) {
                const fieldLeft = label.slice(0, termIndex);
                const fieldRight = label.slice(termIndex + term.length, field.length);
                const untouchedTerm = label.slice(termIndex, termIndex + term.length);

                optionElement = (
                    <div className={optionsClass}
                        onMouseDown={this.handleMouseDown}
                    >
                        {fieldLeft}<span>{untouchedTerm}</span>{fieldRight}<br/>
                        {marketInfo}
                    </div>
                );
            } else {
                optionElement = (
                    <div className={optionsClass}
                        onMouseDown={this.handleMouseDown}
                    >
                        {label}<br/>
                        {marketInfo}
                    </div>
                );
            }

        } else if (option.disabled) {
            const subtitleTextString = `broker-searchMenuSubtitle_${option.label}`;
            optionElement = (
                <div className="broker-search-input-option__results-option-subtitle">
                    <FormattedText value={subtitleTextString} />
                </div>
            );
        } else if (option.hide) {
            optionElement = <span></span>;
        } else {
            optionElement = (
                <div className="broker-search-input-option__results-link-wrapper">
                    <OKButton id="lnk_brokerSearchShowMore" onClick={this.handleMouseDown} modifier="link-complementary">
                        <FormattedText value="broker-searchProductsShowMore" />
                    </OKButton>
                </div>
            );
        }
        return optionElement;
    }
}

WidgetSearchProducts.propTypes = {
    option: PropTypes.object.isRequired,
    isFocused: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
};

module.exports = WidgetSearchProducts;